module.exports = __webpack_public_path__ + "img/eight7Red.376cef2b.jpg";